import type { FC } from "react";
import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../..";
import { getEnv } from "../../../../../AppConfigs";
import { Routes } from "../../../../../AppRoutes";
import { Icon } from "../../../../../components/icon";
import type { ProcessContextType } from "../../../process-context";
import { ProcessContextProvider } from "../../../process-context";
import ItCodeInformation from "./information";
import ItCodeProgress from "./progress";
import { useUser } from "../../../../../hook";
import { useDetailsPCR } from "../hooks/use-details-PCR";
import { Spin } from "antd";
import { useUpdatePCR } from "../hooks/use-update-PCR";

export const siteUrl = getEnv("REACT_APP_APPROVER_IT_CODE_REQUESTS_URL");

export const processCodeGrantedDetailPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [comment, setComment] = useState("");
  const { updatePCRequest } = useUpdatePCR();
  const { email } = useUser();
  const { data: itCodeRequest, isLoading, isPin: hasPin, approvalStep, approvalType } = useDetailsPCR();

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!itCodeRequest) return;
        const pins: any[] = itCodeRequest.fields.ePins ? JSON.parse(itCodeRequest.fields.ePins) : [];
        const index = pins.findIndex((pin: string) => pin === email?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(email?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };

        updatePCRequest(
          { id: itCodeRequest.id, body: fields },
          { successText: hasPin ? "Bỏ ghim thành công" : "Ghim thành công" },
        );
      } catch (error) {
        console.log(error);
      }
    },
    [email, hasPin, itCodeRequest, updatePCRequest],
  );

  const handleGoBack = () => {
    history.push(Routes.procedureProcessVms.path);
  };

  const ctx = useMemo<ProcessContextType>(
    () => ({
      Request: itCodeRequest,
      approvalStep,
      approvalType,
      comment,
      setComment,
      updatePin: handleUpdatePin,
      isPin: () => hasPin,
    }),
    [approvalStep, approvalType, comment, handleUpdatePin, hasPin, itCodeRequest],
  );

  if (isLoading) return <Spin />;

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Yêu Cầu Duyệt"}
        </div>
      </div>

      <ProcessContextProvider context={ctx}>
        <ItCodeProgress />
        <ItCodeInformation />
      </ProcessContextProvider>
    </div>
  );
});
